import styled, { css } from 'styled-components';
import { Button as UnstyledButton } from 'features/common/components/Button';

export const ContainerBody = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 24px 0;
	gap: 24px;
`;

export const ContainerActionButtons = styled.div`
	display: flex;
	gap: 16px;
	justify-content: center;
	padding: 0px;
`;

export const ModalButton = styled(UnstyledButton)`
	font-size: 14px;
	font-weight: 500;
	font-family: ${({ theme }) => theme.fonts.primary};
	height: 44px;
	line-height: 14px;
	padding: 0px;
	width: 125px;
`;

export const FieldLabel = styled.label`
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.black2};
`;

const fieldStyles = css`
	width: 100%;
	height: 40px;
	padding: 8px 12px;
	box-sizing: border-box;
	background-color: #fff;
	border: 1px solid ${({ theme }) => theme.colors.grey19};
	border-radius: 8px;
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 14px;
	color: ${({ theme }) => theme.colors.black2};

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.black2};
	}
`;

export const TextInput = styled.input`
	${fieldStyles}
`;

export const TicketTypeSelect = styled.select`
	${fieldStyles}
	cursor: pointer;
`;
